import {NavLink} from 'react-router-dom';
import Icon from '@frontend/ui-kit/Components/Icon';
import classnames from 'classnames';
import {Props} from './types';
import styles from './index.module.scss';

const SidebarItem = ({title, icon, path}: Props) => {
    const enhancedTitle = title.split('\n').map(str => <div key={str}>{str}</div>);

    return (
        <NavLink to={path}
            data-testid={`sidebar-item-${path.replace('/', '')}`}
            className={({isActive}) => classnames(styles['sidebar-item'], {[styles['sidebar-item_active']]: isActive})}>
            <Icon className={styles['sidebar-item__icon']} type={icon}/>
            <div className={styles['sidebar-item__title']}>{enhancedTitle}</div>
        </NavLink>
    );
};

export {SidebarItem as TestableSidebarItem};
export default SidebarItem;
